import React, { useState, useEffect } from 'react';
import axios from '../../utils/axiosInstance';

const FeedbackReview = () => {
  const [feedbacks, setFeedbacks] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);

  const limit = parseInt(process.env.REACT_APP_PAGE_LIMIT || 10);

  useEffect(() => {
    fetchFeedbacks(currentPage, searchQuery);
    // eslint-disable-next-line
  }, [currentPage, searchQuery]);

  const fetchFeedbacks = async (page = 1, search = '') => {
    try {
      setLoading(true);
      const res = await axios.get(`/admin/api/feedback?page=${page}&limit=${limit}&search=${search}`);
      const feedbackData = res.data.feedbacks || [];
      const totalCount = res.data.totalCount || feedbackData.length;
      setFeedbacks(feedbackData);
      setTotalPages(Math.ceil(totalCount / limit));
    } catch (err) {
      // Optionally show error
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-2">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="mb-0">Feedback & Review</h3>
      </div>

      <div className="card shadow-sm">
        <div className="card-header d-flex justify-content-between align-items-center p-2">
          <h5 className="mb-0">Feedback List</h5>
        </div>
        <div className="table-responsive">
          <div className="card-body p-0">
            <table className="table table-bordered table-sm mb-0" style={{ fontSize: '14px', lineHeight: '2' }}>
              <thead className="table-light">
                <tr>
                  <th className="py-1 px-2 w-5">Sr no.</th>
                  <th className="py-1 px-2">Type</th>
                  <th className="py-1 px-2">Description</th>
                  <th className="py-1 px-2">Image</th>
                  <th className="py-1 px-2">Rating</th>
                  <th className="py-1 px-2">User</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="5" className="text-center py-3">
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </td>
                  </tr>
                ) : feedbacks.length > 0 ? (
                  feedbacks.map((item, idx) => (
                    <tr key={item._id || idx}>
                      <td className="py-1 px-2">{(currentPage - 1) * limit + idx + 1}</td>
                      <td className="py-1 px-2">
                        {item.feedbackType?.name ||
                          item.type ||
                          <span className="text-muted">-</span>
                        }
                      </td>
                      <td className="py-1 px-2" style={{ maxWidth: 350 }}>
                        {item.description
                          ? (item.description.length > 100
                              ? item.description.substring(0, 100) + '...'
                              : item.description
                            )
                          : <span className="text-muted">-</span>
                        }
                      </td>
                      <td className="py-1 px-2">
                        {item.image ? (
                          <img
                            src={item.image}
                            alt="Feedback"
                            style={{
                              width: '60px',
                              height: '40px',
                              objectFit: 'cover',
                              borderRadius: '4px',
                              cursor: 'pointer'
                            }}
                            onClick={() => window.open(item.image, '_blank')}
                            title="Click to view full image"
                          />
                        ) : (
                          <span className="text-muted">No Image</span>
                        )}
                      </td>
                       <td className="py-1 px-2">{item.rating || <span className="text-muted">-</span>}</td>
                      <td className="py-1 px-2">
                        {item.addedBy && typeof item.addedBy === 'object'
                          ? (item.addedBy.email || item.addedBy._id || <span className="text-muted">-</span>)
                          : (item.addedBy || <span className="text-muted">-</span>)
                        }
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center py-2">No Feedback found.</td>
                  </tr>
                )}
              </tbody>
            </table>

            {totalPages > 1 && (
              <div className="d-flex justify-content-end align-items-center gap-2 p-2">
                <button
                  className="btn btn-sm btn-outline-secondary"
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage(currentPage - 1)}
                >
                  &laquo;
                </button>
                {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                  <button
                    key={page}
                    className="btn btn-sm"
                    style={{
                      backgroundColor: currentPage === page ? '#F94F01' : 'transparent',
                      color: currentPage === page ? 'white' : '#F94F01',
                      border: '1px solid #F94F01'
                    }}
                    onClick={() => setCurrentPage(page)}
                  >
                    {page}
                  </button>
                ))}
                <button
                  className="btn btn-sm btn-outline-secondary"
                  disabled={currentPage === totalPages}
                  onClick={() => setCurrentPage(currentPage + 1)}
                >
                  &raquo;
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeedbackReview;